import { SelectionModel } from "@angular/cdk/collections";
import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { MatDateRangePicker } from "@angular/material/datepicker";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { MatPaginator } from "@angular/material/paginator";
import { Router } from "@angular/router";
import { TableComponent } from "src/app/table.component";
import { CareplusNewCustomer } from "src/models/careplus-new-customer";
import { CareplusPolicy } from "src/models/careplus-policy";
import { CareplusPolicyResponse } from "src/models/careplus-policy-response";
import { CareplusPolicyStatus } from "src/models/careplus.constants";
import { CareplusAgencyService } from "src/services/careplus-agency-service";
import { ReportService } from "src/services/report.service";

@Component({
  selector: "app-careplus-policy",
  templateUrl: "./careplus-policy.component.html",
  styleUrls: ["./careplus-policy.component.css"],
})
export class CareplusPolicyComponent extends TableComponent<CareplusPolicyResponse> {
  private _careplusAgencyService: CareplusAgencyService;
  private _reportService = inject(ReportService);
  private _snackBar = inject(MatSnackBar);
  private _router = inject(Router);
  selection = new SelectionModel<any>(true, []);
  statusFilter: string = "POLICY_ISSUED";
  showViewPaymentLog: boolean = true;
  search: string = "";
  issueDateFrom?: any;
  issueDateTo?: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  @ViewChild('picker') picker!: MatDateRangePicker<Date>;
  @ViewChild('startDate') startDate!: ElementRef<HTMLInputElement>;
  @ViewChild('endDate') endDate!: ElementRef<HTMLInputElement>;
  constructor(careplusAgencyService: CareplusAgencyService) {
    super(careplusAgencyService);
    this._careplusAgencyService = careplusAgencyService;
    this.dataSubject.next([]);
  }

  displayedColumns: string[] = [
    "select",
    "id",
    "actions",
    "dataSubmitted",
    "ownerName",
    "email",
    "phoneNumber",
    "totalMembers",
    "policyNumber",
    "policyStartDate",
    "policyEndDate",
    "basePremium",
    "totalFees",
    "totalPolicyAmount",
    "discountAmount",
    "amountPaid",
    "premiumPaid",
    "paymentId",
    "paymentToken",
    "userStatus",
  ];

  ngOnInit(): void {
    super.ngOnInit();
  }

  filter() {
    this.getCount().subscribe((res) => {
      this.count = res.count;
      this.loadRequests();
    });
  }

  override getTableData() {
    return super.getTableData();
  }

  override getCount() {
    return this._careplusAgencyService.getCount({
      filter: this.search,
      status: this.statusFilter,
      startDate: this.issueDateFrom ? new Date(this.issueDateFrom).toISOString() : "",
      endDate: this.issueDateTo ? new Date(this.issueDateTo).toISOString() : "",
    });
  }

  protected override getData(): any {
    let pageSize = this.paginator?.pageSize ? this.paginator.pageSize : 10;
    return {
      skip: (this.paginator?.pageIndex ?? 0) * pageSize,
      take: pageSize,
      filter: this.search,
      orderBy: this.sort?.active,
      orderByDescending: this.sort?.direction === "desc",
      status: this.statusFilter,
      startDate: this.issueDateFrom ? new Date(this.issueDateFrom).toISOString() : "",
      endDate: this.issueDateTo ? new Date(this.issueDateTo).toISOString() : "",
    };
  }

  toggleActive(employee: CareplusNewCustomer, makeActive: boolean) {
    this._careplusAgencyService
      .activateDeactivate(employee.id, makeActive)
      .subscribe({
        next: () => {
          employee.active = makeActive;
        },
        error: (err) => {
          employee.active = !makeActive;
          this._snackBar.open(
            err ||
              `Failed to ${makeActive ? "activate" : "deactivate"} employee.`,
            "CLOSE",
            { horizontalPosition: "right", duration: 4000 },
          );
        },
      });
  }

  openEmployee(row: CareplusPolicyResponse) {
    this._router.navigate(["/careplus-orders", row.transaction.id], {
      state: { isAgencyHr: true },
    });
  }

  downloadReport(isXls: boolean) {
    let pageSize = this.paginator?.pageSize ? this.paginator.pageSize : 10;
    const selectedIds = this.selection.selected.map(
      (row: CareplusPolicyResponse) => row.id,
    );
    const data = {
      skip: (this.paginator?.pageIndex ?? 0) * pageSize,
      take: pageSize,
      filter: this.search,
      orderBy: this.sort?.active,
      orderByDescending: this.sort?.direction === "desc",
      startDate: this.issueDateFrom ? new Date(this.issueDateFrom).toISOString() : "",
      endDate: this.issueDateTo ? new Date(this.issueDateTo).toISOString() : "",
      ids: selectedIds,
    };

    this._reportService.downloadAgencyHRReport(data, isXls);
  }

  getStatusLabel(status: string): string {
    return status === "POLICY_ISSUED" ? "Paid" : "Processing";
  }

  override isAllSelected() {
    const data = this.dataSubject.getValue();
    const numSelected = this.selection.selected.length;
    const numRows = data.length;
    return numSelected === numRows && numRows > 0;
  }

  override masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      const data = this.dataSubject.getValue();
      this.selection.clear();
      data.forEach((row) => this.selection.select(row));
    }
  }
}
